const AUTH_RETURN_TO_KEY = 'club4x4_auth_return_to'

/** True for same-origin relative paths safe for client-side `navigate()`. */
export function isSafeInternalPath(path: string | undefined | null): path is string {
  if (typeof path !== 'string' || path.length === 0) return false
  return path.startsWith('/') && !path.startsWith('//') && !path.startsWith('/\\')
}

/**
 * Post-MFA / re-auth must not land on the consumed email-OTP page (policy onboarding loop).
 * Map that path to the dashboard; leave other safe paths unchanged.
 */
export function normalizeAuthReturnTo(path: string | undefined | null): string | undefined {
  if (!isSafeInternalPath(path)) return undefined
  const pathname = path.split(/[?#]/, 2)[0]
  if (pathname === '/confirm-details/verify') {
    return '/dashboard'
  }
  return path
}

/** Persist post-login destination from Auth0 `appState` (via `onRedirectCallback`). */
export function storeAuthReturnTo(returnTo: unknown): void {
  const normalized = normalizeAuthReturnTo(typeof returnTo === 'string' ? returnTo : undefined)
  if (!normalized) return
  try {
    sessionStorage.setItem(AUTH_RETURN_TO_KEY, normalized)
  } catch {
    /* ignore quota / private mode */
  }
}

/** Read and clear the stored post-login destination (one-shot). */
export function consumeAuthReturnTo(): string | undefined {
  try {
    const value = sessionStorage.getItem(AUTH_RETURN_TO_KEY)
    if (value) sessionStorage.removeItem(AUTH_RETURN_TO_KEY)
    return normalizeAuthReturnTo(value ?? undefined)
  } catch {
    return undefined
  }
}
